<template>
  <ControlUnit :title="$t('control.panel.pose')">
    <InputRadio
      name="avatar-pose"
      :value="currentAvatarPose"
      :options="avatarPoses"
      @change="changeHandler"
    />

    <button
      type="button"
      class="control-panel__btn btn btn--prim"
      @click="clickHandler"
    >{{ $t('control.panel.something_interesting') }}</button>
  </ControlUnit>
</template>

<script>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';

import { runAllWithData } from '@/helpers/functional';

import useStateController from './useStateController';
import useRouteController from './useRouteController';

import ControlUnit from './ControlUnit.vue';
import InputRadio from './InputRadio.vue';

// const getNumberInRange = function (min, max) {
//   let num = min;

//   return function getNumber() {
//     num += 1;

//     if (num > max) {
//       num = min;
//     }

//     return num;
//   };
// };

export default {
  components: {
    ControlUnit,
    InputRadio,
  },
  setup() {
    const unitName = 'avatar-pose';

    const store = useStore();

    const avatarPoses = store.state.control.avatarPoses;

    const currentAvatarPose = computed(() => {
      return String(store.state.control.currentAvatarPose);
    });

    const { changeControlHandler } = useStateController();

    const { setRouteTypeValue, getRouterQueryValue } =
      useRouteController('Control');

    const changeHandler = runAllWithData(
      changeControlHandler,
      setRouteTypeValue
    );

    onMounted(() => {
      const unitQueryValue = getRouterQueryValue(unitName);

      changeControlHandler({
        type: unitName,
        value: unitQueryValue || currentAvatarPose.value,
      });
    });

    //const getNumber = getNumberInRange(1, 5);

    const clickHandler = () => {
      const poseName = 'random'//getNumber();

      changeHandler({
        type: unitName,
        value: poseName,
      });
    };

    return {
      unitName,
      avatarPoses,
      currentAvatarPose,
      changeHandler,
      clickHandler,
    };
  },
};
</script>
